import React, { useState, useEffect } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import ReCaptchaV2 from 'react-google-recaptcha'
import {
    useGoogleReCaptcha, GoogleReCaptchaProvider,
    GoogleReCaptcha
} from "react-google-recaptcha-v3";
const ContactForms = () => {

    // const [token, setToken] = useState();
    // const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
    const [form, setForm] = useState('')
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [status, setStatus] = useState({
        submitted: false,
        submitting: false,
        info: { error: false, msg: null }
    })
    const [inputs, setInputs] = useState({
        fname: '',
        email: '',
        subject: '',
        message: '',
    })
    const handleServerResponse = (ok, msg) => {
        if (ok) {
            setStatus({
                submitted: true,
                submitting: false,
                info: { error: false, msg: msg }
            })
            setInputs({
                fname: '',
                email: '',
                subject: '',
                message: '',
            })
        } else {
            setStatus({
                info: { error: true, msg: msg }
            })
        }
    }
    const handleOnChange = e => {
        e.persist()
        setInputs(prev => ({
            ...prev,
            [e.target.id]: e.target.value
        }))
        setStatus({
            submitted: false,
            submitting: false,
            info: { error: false, msg: null }
        })
    }
    const handleOnSubmit = e => {
        e.preventDefault()
        setStatus(prevStatus => ({ ...prevStatus, submitting: true }))
        axios({
            method: 'POST',
            url: 'https://formspree.io/f/mzbwbodp',
            data: inputs
        })
            .then(response => {
                handleServerResponse(
                    true,
                    'Thank you, your message has been submitted.'
                )
                alert("Thank you for contacting us! We'll be in touch shortly.")
            })
            .catch(error => {
                handleServerResponse(false, error.response.data.error)
            })
    }
    const handleToken = (token) => {
        setForm((currentForm) => {
            return { ...currentForm, token }
        })
    }

    const handleExpire = () => {
        setForm((currentForm) => {
            return { ...currentForm, token: null }
        })
    }


    return (
        <>
            <div className="contact-form">

                <form method="POST" onSubmit={handleOnSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="text-black">Your Name (required)</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="fname"
                                    name="_fname"
                                    onChange={handleOnChange}
                                    required
                                    value={inputs.fname}
                                />

                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="text-black">Your Email (required)</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    name="_email"
                                    onChange={handleOnChange}
                                    required
                                    value={inputs.email}
                                />

                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="text-black">Subject</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="subject"
                                    name="_subject"
                                    onChange={handleOnChange}
                                    required
                                    value={inputs.subject}
                                />

                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="text-black">Your Message</label>
                                <textarea
                                    className="form-control"
                                    defaultValue={""}
                                    id="message"
                                    name="_message"
                                    onChange={handleOnChange}
                                    required
                                    value={inputs.message}
                                />

                            </div>
                        </div>
                        <div className="m-3">
                            <ReCaptchaV2
                                sitekey="6Le2KNkiAAAAAKYiPbdCLDq5L1Rv3cbg-eR_udaE"
                                onChange={handleToken}
                                onExpire={handleExpire}
                            />
                        </div>
                        {/* <div className="col-md-12 captach-row">
                                <div className="form-group">
                                    <img src="images/captcha.png" alt="" />
                                </div>
                            </div> */}
                        <div className="col-md-12 sbmt-btn-wrap">
                            <div className="form-group">
                                <button
                                    type="submit"
                                    className="btn btn-1"
                                    // disabled={state.submitting}
                                    disabled={status.submitting}
                                >
                                    {!status.submitting
                                        ? !status.submitted
                                            ? 'Submit'
                                            : 'Submitted'
                                        : 'Submitting...'}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

        </>

    );
}

export default ContactForms


